export default {
  SET_SUBSCRIBERS_GAINED (state, subscribers_gained) {
    state.subscribers_gained = subscribers_gained
  },

  SET_REVENUE_GENERATED (state, revenueGenerated) {
    state.revenueGenerated = revenueGenerated
  },
  SET_QUARTERLY_SALES (state, quarterlySales) {
    state.quarterlySales = quarterlySales
  },
  SET_ORDER_RECIEVED (state, ordersRecevied) {
    state.ordersRecevied = ordersRecevied
  },
  SET_REVENUE_COMPARISION (state, revenueComparisonLine) {
    state.revenueComparisonLine = revenueComparisonLine
  }
}
